import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
@Directive({
    selector: '[var]',
    standalone: false
})
export class VarDirective<T = unknown> {
    public context: VarContext<T> = {} as any;

    constructor(
        private vcRef: ViewContainerRef,
        private templateRef: TemplateRef<any>,
    ) { }

    @Input('var')
    public set var(context: T) {
        this.context.$implicit = this.context.var = context;
        this.updateView();
    }

    static ngTemplateContextGuard<T>(dir: VarDirective<T>, ctx: any): ctx is VarContext<T> {
        return true;
    }

    private updateView(): void {
        this.vcRef.clear();
        this.vcRef.createEmbeddedView(this.templateRef, this.context);
    }

}

interface VarContext<T> {
    $implicit: T;
    var: T;
}
